<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    id="OffcanvasConfigurationForm"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ $t('Configuration Branch')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="bg-light border-bottom d-flex overflow-x-auto topnav-offcanvas">
        <a
          class="align-content-center col px-3 py-2"
          style="font-size: 13px;"
          :class="tabActive == 'info'? 'active': ''"
          @click="() => {
            tabActive = 'info'
          }"
        >
          {{ $t('General Information') }}
        </a>
        <a
          class="border-start align-content-center col px-3 py-2"
          style="font-size: 13px;"
          :class="tabActive == 'posDevices'? 'active': ''"
          @click="async () => {
            tabActive = 'posDevices';
          }"
        >
          {{ $t('POS Devices') }}
        </a>
        <a
          class="border-start align-content-center col px-3 py-2"
          style="font-size: 13px;"
          :class="tabActive == 'receiptTemplate'? 'active': ''"
          @click="async () => {
            tabActive = 'receiptTemplate';
          }"
        >
          {{ $t('Receipt Template') }}
        </a>
        <a
          class="border-start align-content-center col px-3 py-2"
          style="font-size: 13px;"
          :class="tabActive == 'paymentMethods'? 'active': ''"
          @click="async () => {
            tabActive = 'paymentMethods';
          }"
        >
          {{ $t('Payment Methods') }}
        </a>
        <a
          class="border-start align-content-center col px-3 py-2"
          style="font-size: 13px;"
          :class="tabActive == 'deliveryPlatforms'? 'active': ''"
          @click="async () => {
            tabActive = 'deliveryPlatforms';
          }"
        >
          {{ $t('_delivery.Delivery') }}
        </a>
      </div>
      <div class="border-bottom py-2 px-3">
        <div class="d-flex">
          <div class="row g-3 py-2">
            <b style="font-size: 18px;" class="mt-2">
              {{ $t('Configuration') + ': ' + data.name }}
            </b>
            <div
              class="d-flex mt-0 "
              style="font-size: 13px;"
            >
              <label
                class="pe-2"
              >
                {{ $t('Manage Setting for') + ' ' + data.code + ' ' + $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
          <template
            v-if="tabActive == 'info'"
          >
            <div class="col-md-12">
              <label for="images" class="form-label">{{ $t('Logo') }}</label>
              <vue-upload-multiple-image
                @upload-success="uploadImageSuccess"
                @before-remove="beforeRemove"
                @edit-image="editImage"
                @limit-exceeded="limitExceeded"
                :max-image="image.maxImage"
                :data-images="images"
                :show-primary="image.showPrimary"
                :show-edit="image.showEdit"
                id-upload="myIdUpload"
                edit-upload="myIdEdit"
                :drag-text="$t('Drage Image')"
                :browse-text="$t('Browse Image')"
                primary-text="Base image"
                mark-is-primary-text="Set base image"
                popup-text="default base image"
                :drop-text="$t('Drag and drop')"
                :multiple="false"
              />
              <span class="form-text text-muted">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 50 50">
                  <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"></path>
                </svg>
                {{ this.maxUploadImg }}
              </span>
            </div>
            <div class="col-md-3">
              <label
                for="telephone1"
                class="form-label"
              >
                {{ $t('Telephone') }}
              </label>
              <div class="custom-input-group custom-input-group input-group input-group-sm">
                <input
                  id="telephone1"
                  type="tel"
                  v-model.trim="v$.form.telephone1.$model"
                  class="form-control shadow-none"
                  :placeholder="$t('Enter telephone') + '...'"
                >
                <div v-for="error of v$.form.telephone1.$errors"
                  class="invalid-feedback"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </div>
              </div>
            </div>
            <div class="col-md-9" />
            <div class="col-md-3">
              <label
                for="address"
                class="form-label"
              >
                {{ $t('Address') }}
              </label>
              <div class="custom-input-group custom-input-group input-group input-group-sm">
                <input
                  id="address"
                  type="text"
                  v-model.trim="v$.form.address.$model"
                  class="form-control shadow-none"
                  :placeholder="$t('Enter address') + '...'"
                >
                <div v-for="error of v$.form.address.$errors"
                  class="invalid-feedback"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </div>
              </div>
            </div>
            <div class="col-md-3" >
              <label for="postal_code" class="form-label">
                {{ $t('Zipcode') }}
              </label>
              <div class="custom-input-group custom-input-group input-group input-group-sm">
                <input
                  id="postal_code"
                  type="text"
                  v-model.trim="v$.form.postal_code.$model"
                  class="form-control shadow-none"
                  :placeholder="$t('Enter zipcode') + '...'"
                >
                <div v-for="error of v$.form.postal_code.$errors"
                  class="invalid-feedback"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label
                class="form-label"
              >
                {{ $t('Sub District') }}
              </label>
              <select2
                v-model="v$.form.sub_district.$model"
                :options="districts"
                :settings="select2FormAddress.setting"
                @select="selectAddresses"
              />
            </div>
            <div class="col-md-3">
              <label
                class="form-label"
              >
                {{ $t('District') }}
              </label>
              <select2
                v-model="v$.form.district.$model"
                :options="amphoes"
                :settings="select2FormAddress.setting"
                @select="selectAddresses"
              />
            </div>
            <div class="col-md-3">
              <label
                class="form-label"
              >
                {{ $t('Province') }}
              </label>
              <select2
                v-model="v$.form.province.$model"
                :options="provinces"
                :settings="select2FormAddress.setting"
                @select="selectAddresses"
              />
            </div>
            <!--
              รหัสสถานประกอบการ = ข้อมูลประจำที่ตั้งของสาขา (สรรพากรออกให้ตอนจดทะเบียน VAT)
              อยู่กับที่อยู่/เบอร์ ไม่ใช่แท็บเครื่อง POS — โผล่เฉพาะร้านที่จด VAT
            -->
            <template v-if="previewIsTaxInvoice">
            <div class="col-md-4">
              <label
                for="branchNo"
                class="form-label"
              >
                {{ $t('Branch No') }}
                <span class="text-danger">*</span>
              </label>
              <div class="input-group-sm ">
                <input
                  id="branchNo"
                  type="text"
                  inputmode="numeric"
                  maxlength="5"
                  v-model.trim="v$.form.branch_no.$model"
                  class="form-control shadow-none"
                  placeholder="00000"
                >
                <!--
                  รหัสสถานประกอบการมาจากใบทะเบียนภาษีมูลค่าเพิ่มที่สรรพากรออกให้
                  ร้านสาขาเดียว = สำนักงานใหญ่ = 00000 เสมอ (ไม่ต้องไปขอเลขเพิ่ม)
                -->
                <div class="form-text">
                  {{ $t('Single-location shops use 00000 (head office). Branches use 00001 / 00002 and so on.') }}
                </div>
                <div v-for="error of v$.form.branch_no.$errors"
                  class="d-block invalid-feedback"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </div>
              </div>
            </div>
            </template>
            <!--
              ค่าบริการเป็นการตัดสินใจทางธุรกิจของสาขา ไม่ใช่เรื่องภาษี (บังเอิญเข้าฐาน VAT เท่านั้น)
              จึงอยู่รวมกับข้อมูลสาขาอื่น
            -->
            <div class="col-md-4">
              <label
                for="serviceCharge"
                class="form-label"
              >
                {{ $t('Service Charge') + ' (%)' }}
              </label>
              <div class="input-group-sm ">
                <input
                  id="serviceCharge"
                  type="number"
                  inputmode="decimal"
                  v-model.trim="v$.form.service_charge_rate.$model"
                  class="form-control shadow-none"
                  :placeholder="$t('Enter service charge') + '...'"
                >
                <div v-for="error of v$.form.service_charge_rate.$errors"
                  class="d-block invalid-feedback"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </div>
              </div>
            </div>
          </template>
          <template
            v-else-if="tabActive == 'posDevices'"
          >
            <!--
              ทะเบียนเครื่องที่ออกใบกำกับภาษีอย่างย่อของสาขานี้ (vat-compliance.md D10)
              โผล่เฉพาะร้านที่จด VAT — ร้าน no_tax ใบเสร็จไม่ใช่ใบกำกับ จึงไม่มีเรื่องเครื่องให้ตั้ง
            -->
            <template v-if="previewIsTaxInvoice">
              <pos-devices-tab
                :branch-id="id"
                :branch-config="receiptPrintConfig"
                :shop-tax="shopTax"
              />
            </template>
            <div v-else class="col-12">
              <div class="alert alert-light border d-flex align-items-center gap-2 py-2 mb-0">
                <i class="bi bi-info-circle text-secondary"></i>
                <div class="small">
                  <span class="text-muted">
                    {{ $t('This shop is not VAT-registered — receipts are not tax invoices.') }}
                  </span>
                  <router-link
                    :to="{ name: 'settings' }"
                    class="ms-1"
                  >
                    {{ $t('Edit in shop settings') }}
                  </router-link>
                </div>
              </div>
            </div>
          </template>
          <template
            v-else-if="tabActive == 'paymentMethods'"
          >
            <payment-methods-tab :branch-id="id" />
          </template>
          <template
            v-else-if="tabActive == 'deliveryPlatforms'"
          >
            <delivery-platforms-tab :branch-id="id" />
          </template>
          <template
            v-else-if="tabActive == 'receiptTemplate'"
          >
            <div class="col-md-7 col-lg-8">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body">
                  <h5 class="card-title mb-4">
                    {{ $t('Customize Template') }}
                  </h5>

                  <div class="mb-3">
                    <label class="form-label fw-bold">
                      {{ $t('Header Message') }}
                    </label>
                    <textarea
                      v-model="v$.form.receipt_header.$model"
                      class="form-control shadow-none"
                      rows="3"
                      :placeholder="$t('Ex: Welcome to our restaurant') + '!'"
                    ></textarea>
                    <div class="form-text">
                      {{ $t('Message displayed at the top, below the logo.') }}
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label fw-bold">
                      {{ $t('Footer Message') }}
                    </label>
                    <textarea
                      v-model="v$.form.receipt_footer.$model"
                      class="form-control shadow-none"
                      rows="3"
                      :placeholder="$t('Ex: Thank you very much. Please come again.')"
                    ></textarea>
                    <div class="form-text">
                      {{ $t('Message displayed at the bottom of the receipt.') }}
                    </div>
                  </div>

                  <div class="mb-3">
                    <label
                      for="reviewUrl"
                      class="form-label fw-bold"
                    >
                      {{ $t('Review URL') }}
                      <span
                        class="text-danger"
                        v-if="form.show_qrcode_review"
                      >*</span>
                    </label>
                    <input
                      id="reviewUrl"
                      type="url"
                      v-model.trim="v$.form.review_url.$model"
                      class="form-control shadow-none"
                      :placeholder="'https://g.page/r/xxxx'"
                    >
                    <div class="form-text">
                      {{ $t('Used when generating the review QR (Google / LINE).') }}
                    </div>
                    <div v-for="error of v$.form.review_url.$errors"
                      class="d-block invalid-feedback"
                      :key="error.$uid"
                    >
                      {{ error.$message }}
                    </div>
                  </div>

                  <hr>

                  <h6 class="fw-bold mb-3">
                    {{ $t('Printing') }}
                  </h6>

                  <div class="row g-2 mb-2">
                    <div class="col-md-6">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          id="autoPrintBill"
                          v-model="form.auto_print_bill"
                        >
                        <label class="form-check-label" for="autoPrintBill">
                          {{ $t('Auto-print bill after payment') }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <!--
                    ขนาดกระดาษ/ลิ้นชักย้ายไปตั้งที่เครื่อง (utils/printerSettings.js) เพราะขึ้นกับ
                    เครื่องพิมพ์ที่ต่ออยู่ ไม่ใช่สาขา — บอกไว้ตรงนี้ คนที่เคยตั้งที่นี่จะได้ไม่หา
                  -->
                  <p class="small text-muted mb-0">
                    <i class="fa-solid fa-circle-info me-1"/>
                    {{ $t('_printer.Paper size and cash drawer are set on each device from the printer icon on the top bar') }}
                  </p>

                  <hr>

                  <h6 class="fw-bold mb-1">
                    {{ $t('Display on Receipt') }}
                  </h6>
                  <!--
                    ข้อมูลที่กฎหมายบังคับบนใบรับ (ชื่อ/ที่อยู่/เลขผู้เสียภาษี/เลขที่/วันที่)
                    billReceipt.js พิมพ์เสมอบนใบที่ชำระแล้ว toggle จึงเหลือผลแค่ใบแจ้งรายการ
                    ต้องบอกให้ชัด ไม่งั้นคนตั้งค่าปิด toggle แล้วงงว่าทำไมยังพิมพ์ออกมา
                  -->
                  <p class="small text-muted mb-3">
                    {{ $t('Name address tax ID number and date always print on a paid receipt as required by law. These options affect only the unpaid bill check.') }}
                  </p>

                  <div class="row g-2">
                    <div class="col-md-6" v-for="toggle of receiptToggles" :key="toggle.id">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input shadow-none"
                          type="checkbox"
                          :id="toggle.id"
                          v-model="form[toggle.field]"
                        >
                        <label class="form-check-label" :for="toggle.id">
                          {{ $t(toggle.label) }}
                        </label>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div
              class="card border-0 shadow-sm col-lg-4 col-md-5 p-4"
              style="background-color: #C7C7C7;"
            >
              <!--
                สลับดูใบ 2 ใบที่ระบบพิมพ์จริง — คนตั้งค่ามักไม่รู้ว่า "ก่อนจ่าย" กับ "หลังจ่าย"
                เป็นคนละเอกสารกันตามกฎหมาย (ใบแจ้งรายการ ≠ ใบเสร็จรับเงิน) เห็นทั้งสองใบ
                ในหน้าเดียวจะได้ตรวจได้ว่าตั้งค่าแล้วออกมาถูกทั้งคู่
              -->
              <ul class="nav nav-custom justify-content-center flex-nowrap mb-3">
                <li
                  v-for="stage in previewStages"
                  :key="stage.key"
                  class="nav-item cursor-pointer"
                  @click="previewStage = stage.key"
                >
                  <a class="nav-link text-nowrap py-1" :class="{ active: previewStage === stage.key }">
                    {{ $t(stage.label) }}
                  </a>
                </li>
              </ul>
              <!--
                ขนาดกระดาษเป็นของแต่ละเครื่อง สาขาจึงไม่มีค่าให้อ่าน — สลับดูได้ทั้งสองแบบ
                (ไม่บันทึก) เพราะร้านเดียวมีได้ทั้งเครื่อง 80mm และเครื่องพกพา 58mm
              -->
              <ul class="nav nav-custom justify-content-center flex-nowrap mb-3">
                <li
                  v-for="width in ['80mm', '58mm']"
                  :key="width"
                  class="nav-item cursor-pointer"
                  @click="previewPaperWidth = width"
                >
                  <a class="nav-link text-nowrap py-1" :class="{ active: previewPaperWidth === width }">
                    {{ width }}
                  </a>
                </li>
              </ul>

              <!--
                กว้างเท่าพื้นที่พิมพ์จริงของกระดาษที่เลือก (58mm = 46mm ·
                80mm = 69mm ตาม P ใน utils/billReceipt.js)
                ขนาดตัวอักษรคงที่ทั้งสองแบบเหมือนใบจริง — 58mm จึงตัดบรรทัดถี่กว่า
              -->
              <div
                class="receipt-paper shadow bg-white p-3 font-monospace text-dark"
                :style="previewPaperStyle"
              >

                <div class="text-center mb-3" v-if="form.show_logo">
                  <div
                    class="d-flex align-items-center justify-content-center mx-auto mb-2"
                    style="width: 60px; height: 60px;"
                  >
                    <img
                      :src="images[0]? images[0].path: ''"
                      @error="$storeIndex.onLogoError"
                      style="width: 60px; height: 60px; filter: grayscale(100%);"
                    />
                  </div>
                </div>

                <!--
                  พรีวิวต้องตรงกับที่พิมพ์จริงเสมอ (utils/billReceipt.js)

                  ยังไม่ชำระเงิน           → ใบแจ้งรายการ (ไม่ใช่เอกสารทางภาษี · toggle มีผลเต็มที่)
                  ชำระแล้ว + ร้านจด VAT    → ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ
                  ชำระแล้ว + ร้านไม่จด VAT → ใบเสร็จรับเงิน (ห้ามมีคำว่าใบกำกับภาษี/บรรทัด VAT)

                  ชื่อผู้ประกอบการ · ที่อยู่ · เลขผู้เสียภาษี · เลขที่ · วันที่ = ของบังคับบนใบรับ
                  จึงโชว์เสมอบนใบที่ชำระแล้ว ไม่ขึ้นกับ toggle
                -->
                <div class="text-center mb-2">
                  <div class="fw-bold" style="font-size: 1.4em; line-height: 1.2;">
                    {{ previewIsPaid && shopTax.tax_entity_name ? shopTax.tax_entity_name : $ln($brand) }}
                  </div>
                  <small class="d-block" v-if="previewIsPaid && shopTax.tax_entity_name && shopTax.tax_entity_name !== $brand.name">
                    {{ $ln($brand) }}
                  </small>
                  <small class="d-block" v-if="form.show_branch_name">
                    {{ $t('Branch') + ': ' + data.name }}
                  </small>
                  <small class="d-block" v-if="(previewIsPaid || form.show_branch_address) && fullAddress">
                    {{ fullAddress }}
                  </small>
                  <small class="d-block" v-if="form.show_branch_phone && form.telephone1">
                    {{ $t('Tel') + '. ' + form.telephone1 }}
                  </small>
                </div>

                <small class="d-block text-center" v-if="(previewIsPaid || form.show_tax_id) && shopTax.tax_id">
                  {{ $t('Tax ID') + ': ' + shopTax.tax_id }}
                  <span v-if="previewIsTaxInvoice && form.branch_no">({{ previewBranchLabel }})</span>
                </small>

                <div class="text-center mb-3 small text-break" style="white-space: pre-wrap;" v-if="form.show_receipt_header">
                  {{ form.receipt_header || $t('Welcome to our restaurant')+'!' }}
                </div>

                <div class="text-center fw-bold mb-2">
                  {{ previewDocumentTitle }}
                </div>

                <div class="border-dashed-bottom mb-2"></div>

                <div class="small mb-1">
                  <!-- ใบรับบังคับมีเลขที่ + วันที่เสมอ ไม่ขึ้นกับ toggle show_bill_number -->
                  <template v-if="previewIsPaid && previewIsTaxInvoice">
                    <div class="d-flex justify-content-between">
                      <span>{{ $t('Invoice No.') }}</span>
                      <span>INV-M-001-202602-000001</span>
                    </div>
                    <div class="d-flex justify-content-between">
                      <span>{{ $t('Date') }}</span>
                      <span>12/2/2569 18:30</span>
                    </div>
                    <!-- เลขประจำเครื่องที่สรรพากรออกให้ (ภ.พ.06) — พิมพ์เสมอบนใบกำกับอย่างย่อ -->
                    <div class="d-flex justify-content-between">
                      <span>POS</span>
                      <span>001</span>
                    </div>
                  </template>
                  <template v-else-if="previewIsPaid">
                    <div class="d-flex justify-content-between">
                      <span>{{ $t('Receipt No.') }}</span>
                      <span>M-001-20260212-0001</span>
                    </div>
                    <div class="d-flex justify-content-between">
                      <span>{{ $t('Date') }}</span>
                      <span>12/2/2569 18:30</span>
                    </div>
                  </template>
                  <!-- ใบแจ้งรายการต้องมีเลขอ้างอิงเสมอ ลูกค้าใช้อ้างตอนมาจ่าย -->
                  <div class="d-flex justify-content-between" v-else>
                    <span>{{ $t('Bill No.') }}</span>
                    <span>M-001-20260212-0001</span>
                  </div>
                  <div class="d-flex justify-content-between" v-if="form.show_table_number">
                    <span>{{ $t('Table') }}</span>
                    <span>A-12</span>
                  </div>
                  <div class="d-flex justify-content-between" v-if="form.show_customer_info">
                    <span>{{ $t('Customer') }}</span>
                    <span>คุณสมชาย / 0812345678</span>
                  </div>
                </div>

                <div class="border-dashed-bottom mb-2"></div>

                <!--
                  ตะกร้าชุดเดียวกับใบตัวอย่าง ภ.พ.06 (utils/sampleReceipt.js) รวม 230.00
                  รูปแบบต้องตรงกับ billReceipt.js: ราคาต่อบรรทัด = รวมตัวเลือกแล้ว
                  ตัวเลือกจึงเป็น "หมายเหตุ +10.00" ต่อท้ายชื่อ ไม่ใช่คอลัมน์ยอดที่เอาไปบวกซ้ำ
                  และจำนวน > 1 ขึ้นบรรทัด "2 X 50.00" ใต้ชื่อ ไม่ใช่ (x2) ต่อท้ายชื่อ
                -->
                <div class="small">
                  <div class="d-flex justify-content-between">
                    <span>ก๋วยเตี๋ยวเรือ พิเศษ หมู</span>
                    <span>100.00</span>
                  </div>
                  <div class="text-muted mb-1" style="font-size: 0.85em;">2 X 50.00</div>
                  <div class="d-flex justify-content-between">
                    <span>กากหมู</span>
                    <span>50.00</span>
                  </div>
                  <div class="text-muted mb-1" style="font-size: 0.85em;">2 X 25.00</div>
                  <div class="d-flex justify-content-between">
                    <span>ก๋วยเตี๋ยวเรือ จั๊มโบ เนื้อ</span>
                    <span>80.00</span>
                  </div>
                  <div class="text-muted fst-italic ps-1">- เพิ่ม ลูกชิ้นเนื้อ +10.00</div>
                  <div class="text-muted fst-italic ps-1">- เพิ่ม เนื้อสด +10.00</div>
                  <div class="text-muted fst-italic ps-1 mb-1">- ไม่เผ็ด</div>
                  <div class="text-muted fst-italic ps-2" style="font-size: 0.85em;" v-if="form.show_item_note">
                    * {{ $t('Note') }}: รบกวนเสิร์ฟไว
                  </div>
                </div>

                <div class="border-dashed-bottom my-2"></div>

                <div class="small">
                  <!-- ร้านไม่จด VAT ไม่แยกยอดก่อนภาษี จึงไม่มีบรรทัดรวมย่อย ตรงกับ billReceipt.js -->
                  <div class="d-flex justify-content-between fw-bold" v-if="previewIsTaxInvoice">
                    <span>
                      {{ $t('Subtotal') }}
                    </span>
                    <span>{{ previewAmounts.subtotal }}</span>
                  </div>
                  <!--
                    ตรงกับ billReceipt.js — ไม่มี toggle แล้ว:
                    ค่าบริการโชว์เมื่อสาขาเก็บค่าบริการ (ถูกบวกใน total ไปแล้ว ต้องมีบรรทัดอธิบาย)
                    VAT โชว์เมื่อร้านจด VAT เท่านั้น — ร้านไม่จด VAT ห้ามมีบรรทัดนี้เด็ดขาด
                    (โชว์บนใบแจ้งรายการด้วย เพราะบิลของร้านจด VAT มียอด VAT อยู่จริงตั้งแต่ยังไม่จ่าย)
                  -->
                  <div
                    class="d-flex justify-content-between"
                    v-if="form.service_charge_rate"
                  >
                    <span>
                      {{ $t('Service Charge') + ' (' + form.service_charge_rate + '%)' }}
                    </span>
                    <span>{{ previewAmounts.service }}</span>
                  </div>
                  <template v-if="previewIsTaxInvoice">
                    <div class="d-flex justify-content-between">
                      <span>
                        {{ $t('Amount before VAT') }}
                      </span>
                      <span>{{ previewAmounts.before_vat }}</span>
                    </div>
                    <div class="d-flex justify-content-between">
                      <span>
                        {{ $t('_Bill.VAT') + ' (' + (shopTax.vat_rate || 7) + '%)' }}
                      </span>
                      <span>{{ previewAmounts.vat }}</span>
                    </div>
                  </template>
                  <div class="d-flex justify-content-between fw-bold mt-2" style="font-size: 1.1em;">
                    <span>
                      {{ $t('TOTAL') }}
                    </span>
                    <span>{{ previewAmounts.total }}</span>
                  </div>
                  <!-- ข้อความบังคับของใบกำกับอย่างย่อ — ใบแจ้งรายการยังไม่ใช่ใบกำกับ จึงห้ามมี -->
                  <div class="text-center small mt-2" v-if="previewIsPaid && previewIsTaxInvoice">
                    {{ $t('Prices shown include VAT') }}
                  </div>
                </div>

                <div class="border-dashed-bottom my-2"></div>

                <div
                  class="d-flex justify-content-center gap-3 my-3"
                  v-if="form.show_qrcode_promptpay || form.show_qrcode_review"
                >
                  <div class="text-center" v-if="form.show_qrcode_promptpay">
                    <div
                      class="bg-light border d-flex align-items-center justify-content-center mx-auto"
                      style="width: 70px; height: 70px;"
                    >
                      <i class="fa-solid fa-qrcode fs-2 text-muted"></i>
                    </div>
                    <small class="d-block mt-1" style="font-size: 0.8em;">PromptPay</small>
                  </div>
                  <div class="text-center" v-if="form.show_qrcode_review">
                    <div
                      class="bg-light border d-flex align-items-center justify-content-center mx-auto"
                      style="width: 70px; height: 70px;"
                    >
                      <i class="fa-solid fa-qrcode fs-2 text-muted"></i>
                    </div>
                    <small class="d-block mt-1" style="font-size: 0.8em;">{{ $t('Review') }}</small>
                  </div>
                </div>

                <!-- กันเข้าใจผิดว่าเป็นใบเสร็จ — ต้องอยู่ก่อนข้อความท้ายบิลของร้าน -->
                <div class="text-center small mt-3" v-if="!previewIsPaid">
                  * {{ $t('This document is not a receipt or a tax invoice.') }}
                </div>

                <div class="text-center mt-3 small text-break" style="white-space: pre-wrap;" v-if="form.show_receipt_footer">
                  {{ form.receipt_footer || $t('Thank you very much.') + '\n' + $t('Please come again.') }}
                </div>

                <div class="text-center mt-4 text-muted" style="font-size: 0.8em;">
                  {{ new Date().toLocaleString() }}
                </div>
                <!-- บรรทัดผู้ให้บริการระบบ ล่างสุดจริงๆ เหมือนใบจริง (ปิดได้ที่ WEB_POWERED_BY) -->
                <div class="text-center text-muted" style="font-size: 0.75em;" v-if="poweredBy">
                  {{ 'Powered by ' + poweredBy }}
                </div>

              </div>

              <div class="text-center mt-3 small text-dark-emphasis">
                {{ previewPaperCaption }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!--
      แท็บที่จัดการ sub-entity ของตัวเอง (มีปุ่มบันทึกในแท็บอยู่แล้ว) ต้องซ่อน footer save
      ไม่งั้นได้ปุ่มบันทึก 2 ตัวในหน้าเดียวซึ่งชวนสับสนว่ากดอันไหนบันทึกอะไร
    -->
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading && hasPermission && !selfSavingTabs.includes(tabActive)"
    >
      <ladda
        text="Save"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleEdit"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-configuration";
import { Branches } from '@/services/endpoint/branches.service';
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';
import signature  from '@/services/signature';
import { searchAddressByZipcode } from 'thai-address-database';
import moment from "moment";
import VueUploadMultipleImage from '@/plugins/VueUploadMultipleImage.vue';
import PaymentMethodsTab from './PaymentMethodsTab.vue';
import DeliveryPlatformsTab from './DeliveryPlatformsTab.vue';
import PosDevicesTab from './PosDevicesTab.vue';
import { apiErrorText } from '@/utils/apiError';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.form, this.shopTax)
  },
  props: {
    type: {
      type: String,
      default: 'CREATE'
    },
    id: {
      type: Number,
      default: 0
    },
  },
  data() {
    let vm = this;
    return {
      tabActive: 'info',
      select2FormAddress: {
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      loading: true,
      hasPermission: false,
      loadingSave: false,
      data: {
        name: '',
        code: '',
        updated_at: '',
      },
      form: {
        logo: '',
        remove_logo: '',
        telephone1: '',
        telephone2: '',
        address: '',
        postal_code: '',
        sub_district: '0',
        district: '0',
        province: '0',
        branch_no: '',
        service_charge_rate: '',
        receipt_header: '',
        receipt_footer: '',
        review_url: '',
        show_logo: false,
        show_tax_id: false,
        show_receipt_header: false,
        show_receipt_footer: false,
        show_branch_name: false,
        show_branch_address: false,
        show_branch_phone: false,
        show_table_number: false,
        show_customer_info: false,
        show_qrcode_promptpay: false,
        show_qrcode_review: false,
        show_item_note: false,
        show_bill_number: false,
        auto_print_bill: true,
      },
      image: {
        maxImage: 1,
        maxSize: 5,
        showPrimary: false,
        showEdit: false
      },
      images: [],
      // อ่านอย่างเดียว — ค่าภาษีตั้งที่หน้าตั้งค่าร้าน (ดู filter.shop_tax ของ endpoint นี้)
      // ใช้ประกอบ preview ใบเสร็จให้ตรงกับที่พิมพ์จริง + ตัดสินว่าต้องกรอก branch_no ไหม
      shopTax: {
        tax_policy: 'no_tax',
        vat_rate: 0,
        tax_id: '',
        tax_entity_name: '',
      },
      // แท็บพรีวิว — ตั้งต้นที่ใบหลังชำระเงิน เพราะเป็นใบที่กฎหมายบังคับหน้าตามากที่สุด
      previewStage: 'paid',
      // ขนาดกระดาษของพรีวิวอย่างเดียว ไม่บันทึก — ค่าจริงอยู่ที่แต่ละเครื่อง (printerSettings)
      previewPaperWidth: '80mm',
    }
  },
  components: {
    PlaceholderContent,
    Ladda,
    AccessDenied,
    Select2,
    VueUploadMultipleImage,
    PaymentMethodsTab,
    DeliveryPlatformsTab,
    PosDevicesTab
  },
  methods: {
    uploadImageSuccess(formData, index, fileList, fileSize) {
      let imgSize = fileSize / 1000000;
      let imgList = fileList;
      if (index >= this.image.maxImage || imgSize > this.image.maxSize) {
        imgList.splice(index, 1);
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.maxUploadImg);
        return;
      }
      this.images = imgList;
      this.form.logo = imgList[0].path;
    },
    beforeRemove(index, done, fileList, mediaId) {
      if (mediaId) this.form.remove_logo = true;
      done();
      this.images = fileList;
      this.form.logo = '';
    },
    editImage(formData, index, fileList) {
      // ไม่ต้องส่ง remove_logo — ฝั่ง API ลบไฟล์โลโก้เดิมให้เองเมื่อ path เปลี่ยน
      this.images = fileList;
      this.form.logo = fileList[index].path;
    },
    limitExceeded(limit) {
      this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.maxUploadImg);
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    async getConfigurationData() {
      await Branches.getConfiguration(this.id).then(res => {
        this.shopTax = res.data.filter?.shop_tax || this.shopTax;
        if (res.data.data.logo_url) {
          this.images = [
            {
              id: 1,
              default: 1,
              highlight: 1,
              name: 'logo',
              path: res.data.data.logo_url,
              type: 'old'
            }
          ];
        }
        this.data = res.data.data;
        this.form.telephone1 = res.data.data.telephone1;
        this.form.address = res.data.data.address;
        this.form.postal_code = res.data.data.postal_code || '';
        setTimeout(() => {
          this.form.sub_district = res.data.data.sub_district || 0;
          this.form.district = res.data.data.district || 0;
          this.form.province = res.data.data.province || 0;
        }, 1);
        this.form.branch_no = res.data.data.branch_no || '';
        this.form.service_charge_rate = res.data.data.service_charge_rate;
        this.form.receipt_header = res.data.data.receipt_header;
        this.form.receipt_footer = res.data.data.receipt_footer;
        this.form.review_url = res.data.data.review_url || '';
        this.form.show_logo = res.data.data.show_logo ?? false;
        this.form.show_tax_id = res.data.data.show_tax_id ?? false;
        this.form.show_receipt_header = res.data.data.show_receipt_header ?? false;
        this.form.show_receipt_footer = res.data.data.show_receipt_footer ?? false;
        this.form.show_branch_name = res.data.data.show_branch_name ?? false;
        this.form.show_branch_address = res.data.data.show_branch_address ?? false;
        this.form.show_branch_phone = res.data.data.show_branch_phone ?? false;
        this.form.show_table_number = res.data.data.show_table_number ?? false;
        this.form.show_customer_info = res.data.data.show_customer_info ?? false;
        this.form.show_qrcode_promptpay = res.data.data.show_qrcode_promptpay ?? false;
        this.form.show_qrcode_review = res.data.data.show_qrcode_review ?? false;
        this.form.show_item_note = res.data.data.show_item_note ?? false;
        this.form.show_bill_number = res.data.data.show_bill_number ?? false;
        this.form.auto_print_bill = res.data.data.auto_print_bill ?? true;
        this.hasPermission = true;
      }).catch(err => {
			  throw err;
      });
    },
    setParamsBeforeSendUpdate() {
      let params = _.cloneDeep(this.form);
      params.review_url = params.show_qrcode_review ? (params.review_url || null) : null;
      $.each(params, (key, value) => {
        if (typeof value === 'boolean') return;
        if (key === 'review_url') return;
        if (value === null || value === "" || (value && value.length === 0)) {
          delete params[key];
        }
        if (
          (key == 'address' ||
          key == 'postal_code' ||
          key == 'sub_district' ||
          key == 'district' ||
          key == 'province') && value == '0'
        ) {
          delete params[key];
        }
      });
      return params;
    },
    async handleEdit() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await Branches.updateConfiguration(this.id, this.setParamsBeforeSendUpdate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Branch!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        const detail = apiErrorText(err, (key) => this.$t(key));
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.$t('Save Failed!') + (detail ? "\n" + detail : ''));
        this.loadingSave = false;
      });
    },
    selectAddresses({ id, text, module }) {
      if (module == 'sub_district') {
        if (id != '0') {
          let address = this.addresses.find((addresse) => addresse.district == id);
          this.form.district = address.amphoe;
          this.form.province = address.province;
          this.form.postal_code = address.zipcode;
        }
      }

      if (module == 'district') {
        this.form.sub_district = '0';
        if (id != '0') {
          let address = this.addresses.find((addresse) => addresse.amphoe == id);
          this.form.province = address.province;
          this.form.postal_code = address.zipcode;
        }
      }

      if (module == 'province') {
        this.form.sub_district = '0';
        this.form.district = '0';
        if (id != '0') {
          let address = this.addresses.find((addresse) => addresse.province == id);
          this.form.postal_code = address.zipcode;
        }
      }
    },
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        await this.getConfigurationData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$parent.offcanvasConfigurationForm.open = false;
    });
  },
  computed: {
    // แท็บที่บันทึกเองผ่าน endpoint ของ sub-entity — footer save ของ offcanvas ไม่เกี่ยวกับมัน
    selfSavingTabs() {
      return ['paymentMethods', 'deliveryPlatforms', 'posDevices'];
    },
    maxUploadImg: function() {
      return this.$t('You can choose to upload a maximum of') + ' ' + this.image.maxImage + ' ' + this.$t('imaes. The size is not over') + ' ' + this.image.maxSize + ' ' + this.$t('MB.');
    },
    // ร้านที่จด VAT → ใบเสร็จคือใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ พรีวิวต้องสะท้อนแบบนั้น
    // (ตรงกับเงื่อนไข isAbbrTaxInvoice ใน utils/billReceipt.js)
    previewIsTaxInvoice() {
      return !!this.shopTax.tax_policy && this.shopTax.tax_policy !== 'no_tax';
    },
    // อ่านจาก runtime config เดียวกับที่ billReceipt.js ใช้ (ตั้ง WEB_POWERED_BY="" เพื่อปิด)
    poweredBy() {
      return process.env.VUE_APP_POWERED_BY;
    },
    /**
     * branch_config ที่ส่งให้ตัวพิมพ์ใบเสร็จ (ตอนนี้ใช้กับใบตัวอย่าง ภ.พ.06 ที่แท็บเครื่อง POS)
     *
     * ใช้ค่าที่กำลังอยู่บนฟอร์ม ไม่ใช่ค่าที่บันทึกไว้ — คนตั้งค่าจะได้ลองพิมพ์ดูก่อนกดบันทึกได้
     * เติม 2 ฟิลด์ที่ฟอร์มไม่ได้ถือเอง: ชื่อสาขา และ URL โลโก้ที่อัปโหลดไว้
     */
    receiptPrintConfig() {
      return {
        ...this.form,
        name: this.data.name,
        logo_url: this.images[0]?.path || '',
      };
    },
    previewStages() {
      return [
        { key: 'unpaid', label: 'Before Payment' },
        { key: 'paid', label: 'After Payment' },
      ];
    },
    previewIsPaid() {
      return this.previewStage === 'paid';
    },
    /**
     * ชื่อเอกสาร 3 แบบ ต้องตรงกับ documentTitle ใน utils/billReceipt.js เป๊ะ ๆ
     * แก้ที่ไหนต้องแก้อีกที่เสมอ ไม่งั้นพรีวิวโกหกคนตั้งค่า
     */
    previewDocumentTitle() {
      if (!this.previewIsPaid) return this.$t('Bill Check');
      return this.previewIsTaxInvoice
        ? this.$t('Receipt/Abbreviated Tax Invoice')
        : this.$t('Receipt');
    },
    /**
     * ความกว้างพื้นที่พิมพ์จริงของกระดาษที่เลือก (ไม่ใช่ความกว้างม้วนกระดาษ)
     * คิดจาก P ใน utils/billReceipt.js: pageWidth − sideMargin ทั้งสองข้าง
     *   58mm → 136.06 − 2×2.83 = 130.40pt = 46mm
     *   72mm/80mm → 204.09 − 2×4.25 = 195.59pt = 69mm  (สองค่านี้พิมพ์เหมือนกันเป๊ะ)
     *
     * ⚠️ ห้ามย่อฟอนต์ตามขนาดกระดาษ — ใบจริง **ใช้ pt เท่ากันทั้ง 2 ขนาด** โดยตั้งใจ
     * (ดูคอมเมนต์ "same font sizes (kept readable)" ที่ billReceipt.js)
     * กระดาษ 58mm จึงตัดบรรทัดถี่กว่า ไม่ใช่ตัวหนังสือเล็กลง ถ้าพรีวิวย่อฟอนต์ด้วย
     * จะโกหกคนตั้งค่าว่าใส่ได้เยอะกว่าความจริง
     */
    previewPaper() {
      const map = {
        '58mm': 46,
        '80mm': 69,
      };
      return { printable: map[this.previewPaperWidth] || 69 };
    },
    previewPaperStyle() {
      // content-box (ตั้งใน <style>) ทำให้ width = พื้นที่พิมพ์จริง ส่วน padding อยู่นอกออกไป
      // 12px เทียบกับ 69mm = อัตราส่วนเดียวกับตัวอักษร 8pt บนหน้ากระดาษ 195.59pt ของใบจริง
      return {
        width: this.previewPaper.printable + 'mm',
        fontSize: '12px',
      };
    },
    previewPaperCaption() {
      const paper = this.previewPaperWidth;
      return `${this.$t('Bill Paper Width')}: ${paper} (${this.$t('printable')} ${this.previewPaper.printable}mm)`;
    },
    /**
     * ยอดตัวอย่างในพรีวิว — คำนวณจากรายการสมมุติ 230.00 ให้ขยับตามค่าบริการ/อัตราภาษีที่ตั้งไว้จริง
     * ไม่ hardcode ตัวเลข เพราะพรีวิวที่บวกเลขไม่ลงตัวทำให้คนตั้งค่าไม่เชื่อว่าใบจริงถูก
     *
     * ถอด VAT ออกจากยอดรวมเสมอ (ทั้ง included และ excluded) — ตรงกับ SaleOrderHelper
     * ที่บวก VAT เข้าราคาตั้งแต่ระดับ item แล้ว ยอดบนใบจึงเป็นราคารวม VAT ทั้งคู่
     */
    previewAmounts() {
      const fmt = (n) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const subtotal = 230;
      const rate = Number(this.form.service_charge_rate) || 0;
      const service = +(subtotal * rate / 100).toFixed(2);
      const total = +(subtotal + service).toFixed(2);
      const vatRate = Number(this.shopTax.vat_rate) || 7;
      const vat = this.previewIsTaxInvoice ? +(total * vatRate / (100 + vatRate)).toFixed(2) : 0;
      return {
        subtotal: fmt(subtotal),
        service: fmt(service),
        before_vat: fmt(+(total - vat).toFixed(2)),
        vat: fmt(vat),
        total: fmt(total),
      };
    },
    shopTaxPolicyText() {
      const map = {
        included: this.$t('VAT Included'),
        excluded: this.$t('VAT Excluded'),
        no_tax: this.$t('No Tax'),
      };
      return map[this.shopTax.tax_policy] || map.no_tax;
    },
    previewBranchLabel() {
      const value = String(this.form.branch_no || '').trim();
      if (!value) return '';
      return /^0+$/.test(value) ? this.$t('Head Office') : this.$t('Branch No') + ' ' + value;
    },
    fullAddress() {
      const parts = [
        this.form.address,
        this.form.sub_district !== '0' ? this.form.sub_district : '',
        this.form.district !== '0' ? this.form.district : '',
        this.form.province !== '0' ? this.form.province : '',
        this.form.postal_code,
      ].filter(Boolean);
      return parts.join(' ');
    },
    receiptToggles() {
      return [
        { id: 'showLogo', field: 'show_logo', label: 'Show Logo' },
        { id: 'showBranchName', field: 'show_branch_name', label: 'Show Branch Name' },
        { id: 'showBranchAddress', field: 'show_branch_address', label: 'Show Branch Address' },
        { id: 'showBranchPhone', field: 'show_branch_phone', label: 'Show Branch Phone' },
        { id: 'showReceiptHeader', field: 'show_receipt_header', label: 'Show Header Message' },
        { id: 'showReceiptFooter', field: 'show_receipt_footer', label: 'Show Footer Message' },
        { id: 'showBillNumber', field: 'show_bill_number', label: 'Show Bill Number' },
        { id: 'showTableNumber', field: 'show_table_number', label: 'Show Table Number' },
        { id: 'showCustomerInfo', field: 'show_customer_info', label: 'Show Customer Info' },
        { id: 'showItemNote', field: 'show_item_note', label: 'Show Item Note' },
        { id: 'showQrcodePromptpay', field: 'show_qrcode_promptpay', label: 'Show PromptPay QR' },
        { id: 'showQrcodeReview', field: 'show_qrcode_review', label: 'Show Review QR' },
      ];
    },
    addresses() {
      return searchAddressByZipcode(this.form.postal_code, 100);
    },
    districts() {
      if (!this.addresses.find((addresse) => addresse.district == this.form.sub_district)) {
        this.form.sub_district ='0';
      }
      return [
        {
          id: '0',
          text: this.$t('Select')+'...',
          module: 'sub_district'
        }
      ].concat([...new Set(this.addresses.map(item => item.district))].map(item => { return { id: item, text: item, module: 'sub_district' } }));
    },
    amphoes() {
      if (!this.addresses.find((addresse) => addresse.amphoe == this.form.district)) {
        this.form.district ='0';
      }
      return [
        {
          id: '0',
          text: this.$t('Select')+'...',
          module: 'district'
        }
      ].concat([...new Set(this.addresses.map(item => item.amphoe))].map(item => { return { id: item, text: item, module: 'district' } }));
    },
    provinces() {
      if (!this.addresses.find((addresse) => addresse.province == this.form.province)) {
        this.form.province ='0';
      }
      return [{ id: '0', text: this.$t('Select')+'...', module: 'province' }].concat([...new Set(this.addresses.map(item => item.province))].map(item => { return { id: item, text: item, module: 'province' } }));
    },
  }
}
</script>

<style scoped>
/*
  กระดาษพรีวิว — กว้างเท่าพื้นที่พิมพ์จริงของกระดาษที่เลือก (ค่ามาจาก previewPaperStyle)
  ต้องเป็น content-box เพื่อให้ width หมายถึง "พื้นที่พิมพ์" ล้วน ๆ ส่วน padding ของกระดาษ
  อยู่นอกออกไป (bootstrap ตั้ง border-box ไว้ทั้งหน้า จึงต้อง override ตรงนี้)

  จอแคบกว่ากระดาษก็ต้องไม่ล้นออกนอกการ์ด จึงมี max-width กำกับไว้
*/
.receipt-paper {
  box-sizing: content-box;
  margin-inline: auto;
  max-width: 100%;
  line-height: 1.35;
}
</style>
